import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useSelector } from "react-redux";
import NoDataFound from "../components/NoDataFound";
import BoardMemeberAlert from "../components/elements/alert/BoardMemeberAlert";
import CardAction from "../components/Common/CardAction";
import { useNavigate } from "react-router-dom";
import ManageInviteExecutivePopup from "../components/popup/ManageInviteExecutivePopup";
import SurveyPopup from "../components/popup/SurveyPopup";
import InvitationPopup from "../components/popup/InvitationPopup";
import SurveyHistoryPopup from "../components/popup/SurveyHistoryPopup";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import ProfileCardSkeleton from "../components/loader/ProfileCardSkeleton";
import ResendSurveyPopup from "../components/popup/ResendSurveyPopup";
import moment from "moment";
import Indentification from "../components/elements/Indentification";
import { initialsValue } from "../helpers";
import { Tooltip } from "react-tooltip";
import ManagePasswordPopup from "../components/popup/ManagePasswordPopup";

const Executives = () => {
  setTitle("Succession Now | Executives");
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const user = useSelector((state) => state.auth?.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const limit = 10;
  const [offset, setOffset] = useState(0);
  const [executives, setExecutives] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [reatingOptions, setReatingOptions] = useState([]);
  const [enabledInviteExecutivePopup, setEnabledInviteExecutivePopup] =
    useState(false);
  const [inviteInfo, setInviteInfo] = useState({});
  const [enabledSurveyPopup, setEnabledSurveyPopup] = useState(false);
  const [detailsId, setDetailsId] = useState("");
  const [answers, setAnswers] = useState([]);
  const [enabledInvitationPopup, setEnabledInvitationPopup] = useState(false);
  const [details, setDetails] = useState({});
  const [enabledSurveyHistoryPopup, setEnabledSurveyHistoryPopup] =
    useState(false);
  const [completedUsers, setCompletedUsers] = useState([]);
  const [resendSurveyOpen, setResendSurveyOpen] = useState({
    isOpen: false,
    data: null,
  });
  const [selectedMember, setSelectedMember] = useState([]);
  const [areAllSelected, setAreAllSelected] = useState(false);
  const [enabledPasswordManagePopup, setEnabledPasswordManagePopup] =
    useState(false);
  const [passwordInfo, setPasswordInfo] = useState({});
  const [assignEmployees, setAssignEmployees] = useState([]);

  useEffect(() => {
    if (
      (role && (role !== "customer-admin" && role !== "customer-subadmin")) ||
      user?.plan_alias === "professional-plan"
    ) {
      return navigate("/dashboard");
    }
  }, [role, user]);

  useEffect(() => {
    async function employeeRatingOptionList() {
      try {
        const result = await postData("employee-rating-option/list", {
          sortQuery: { created_at: 1 },
          status: 1,
          limit: 50,
          type: "executive",
        });
        if (result.data) {
          setReatingOptions(result.data);
        } else {
          console.log("Advance desire message", result.message);
        }
      } catch (error) {
        console.log("Error advance desire catch", error.message);
      }
    }
    employeeRatingOptionList();
  }, []);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("executive/list", {
        offset: offset,
        sortQuery: { created_at: 1 },
        outside_candidate: 2,
      });
      if (result.data) {
        setExecutives(
          result.data?.sort((a, b) => a.first_name.localeCompare(b.first_name))
        );
      }
      setTotalDataCount(result.count);
      setLoading(false);
      setIsUpdate(false);
    } catch (err) {
      console.error(err.message);
      setIsUpdate(false);
    } finally {
      setLoading(false);
      setIsUpdate(false);
    }
  }, [offset,isUpdate]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const getInitials = function (string) {
    var names = string.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };
  
  useEffect(() => {
    if (
      actionValue &&
      actionValue.button_type === "send-invitation-executive"
    ) {
      setEnabledInviteExecutivePopup(true);
      setInviteInfo({
        _id: actionValue.row_id,
      });
    } else if (
      actionValue &&
      actionValue.button_type === "resend-invitation-executive"
    ) {
      const loadResendInvitation = async () => {
        try {
          const othersData = await postData("executive/invitation-resend", {
            id: actionValue?.row_id,
          });
          if (othersData.data) {
            setActionValue({});
            toastr.success(
              "Email resent.Please make sure to check your spam email."
            );
          } else {
            toastr.error(othersData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadResendInvitation();
    } else if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        try {
          const statusData = await postData("executive/delete", {
            id: actionValue?.row_id,
          });
          if (statusData.data) {
            const index = executives.findIndex(
              (item) => item._id === actionValue?.row_id
            );
            if (index !== -1) {
              executives.splice(index, 1);
              setExecutives(
                executives.map((it) => {
                  return it;
                })
              );
            }
            setExecutives((prevExecutives) => prevExecutives.filter((item) => item._id !== actionValue.row_id));
          } else {
            toastr.error(statusData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      loadDeleteRecord();
    } else if (
      actionValue &&
      (actionValue.button_type === "survey" ||
        actionValue.button_type === "survey-history")
    ) {
      const loadExecutiveDetails = async () => {
        try {
          const result = await postData("executive/details", {
            _id: actionValue?.row_id,
          });
          if (result.status === 403) {
            return navigate("/executives");
          } else {
            if (result.data) {
              if (actionValue.button_type === "survey") {
                if (
                  result?.data?.executiveAudits &&
                  result?.data?.executiveAudits.length > 0
                ) {
                  setAnswers(
                    reatingOptions.map((value) => {
                      let _question = result?.data?.executiveAudits.filter(
                        (it) => it?.questionId === value?.question?._id
                      );
                      if (_question.length > 0) {
                        return {
                          ..._question[0],
                          ids: _question[0]?.ids,
                          questionInfo: value,
                        };
                      } else {
                        return {
                          questionId: value?.question?._id,
                          answerId: null,
                          answerLabel: null,
                          rating: 0,
                          comments: null,
                          questionInfo: value,
                        };
                      }
                    })
                  );
                } else {
                  setAnswers(
                    reatingOptions.map((value) => {
                      return {
                        questionId: value?.question?._id,
                        answerId: null,
                        answerLabel: null,
                        rating: 0,
                        comments: null,
                        questionInfo: value,
                      };
                    })
                  );
                }
              } else if (actionValue.button_type === "survey-history") {
                setDetails(result.data);
              }
            }
            setDetailsId(actionValue?.row_id);
            if (actionValue.button_type === "survey") {
              setEnabledSurveyPopup(true);
            } else if (actionValue.button_type === "survey-history") {
              setEnabledSurveyHistoryPopup(true);
            }
          }
        } catch (err) {
          console.log(err.message);
        }
      };
      loadExecutiveDetails();
    } else if (actionValue && actionValue.button_type === "update-survey") {
      const onSubmit = async () => {
        try {
          const result = await postData("executive/update", {
            id: detailsId,
            ratingOptions: actionValue?.answers,
          });
          if (result.status && result.status === 200) {
            toastr.success(result.message);
            setDetailsId("");
            loadList();
          } else {
            toastr.error(result.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
      };
      onSubmit();
    } else if (actionValue && actionValue.button_type === "resendSurvey") {
      setResendSurveyOpen({ isOpen: true, data: actionValue?.row_id });
    } else if (actionValue && actionValue.button_type === "update-password") {
      setEnabledPasswordManagePopup(true);
      setPasswordInfo({
        _id: actionValue?.row_id?.parent_id,
        data: actionValue?.row_id?.first_name
          ? {
              company_name: actionValue?.row_id?.first_name
                ? actionValue?.row_id?.first_name +
                  " " +
                  actionValue?.row_id?.last_name
                : "N/A",
            }
          : "N/A",
      });
    }
  }, [actionValue]);

  const filterExecutives = (totalQuestion) => {
    if (!executives || executives.length === 0 || totalQuestion === 0) return;

    const completedExecutives = executives.filter((executive) => {
      const answeredQuestions = executive?.executiveAudits?.filter(
        (audit) => audit?.answerId !== null || (audit?.ids?.length || 0) > 0
      );
      return answeredQuestions.length === totalQuestion;
    });

    setCompletedUsers(completedExecutives);
  };

  useEffect(() => {
    let totalQuestion = reatingOptions?.length;
    filterExecutives(totalQuestion);
  }, [reatingOptions, executives]);

  // useEffect(() => {
  //   setNoOfPage(Math.ceil(totalDataCount / limit));
  //   const startItem = Number(totalDataCount > 0 ? 1 : 0);
  //   const endItem = Math.min(startItem + limit - 1, totalDataCount);
  //   setStartDataCount(startItem);
  //   setEndDataCount(endItem);
  //   if (keyword) {
  //     setOffset(0);
  //   }
  // }, [limit, totalDataCount,keyword]);

  // const handlePageClick = (event) => {
  //   const newOffset = (event.selected * limit) % totalDataCount;
  //   // console.log(
  //   //   `User requested page number ${event.selected}, which is offset ${newOffset}`
  //   // );
  //   setOffset(newOffset);
  //   const startItem = Number(newOffset + 1);
  //   const endItem = Math.min(startItem + limit - 1, totalDataCount);
  //   setStartDataCount(startItem);
  //   setEndDataCount(endItem);
  //   setSelectedMember([]);
  // };

  const handleSelectedMember = (item) => {
    setSelectedMember((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (member) => member?._id === item?._id
      );

      if (isAlreadySelected) {
        return prevSelected.filter((member) => member?._id !== item?._id);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleSelectAll = () => {
    const filteredMembers = executives.filter((member) => member.parent_id);

    if (selectedMember.length === filteredMembers.length) {
      setSelectedMember([]);
    } else {
      setSelectedMember(filteredMembers);
    }
  };

  useEffect(() => {
    const filteredMembers = executives?.filter((member) => member?.parent_id);
    const isAllSelected =
      selectedMember.length === filteredMembers.length &&
      filteredMembers.length !== 0;

    if (isAllSelected) {
      setAreAllSelected(true);
    } else {
      setAreAllSelected(false);
    }
  }, [selectedMember, executives, areAllSelected]);

  // Assign  List APi Call
  useEffect(() => {
    async function employeeData() {
      try {
        const result = await postData("assign/list", {
          sortQuery: { created_at: -1 },
          status: 1,
          is_invited: 1,
        });
        if (result?.data) {
          setAssignEmployees(
            result?.data?.length > 0 &&
              result?.data?.map((items) => {
                let firstName = "";
                let lastName = "";
                if (!items?.first_name) {
                  let nameParts = items?.name?.split(/\s+/);
                  firstName = nameParts?.[0] || "";
                  lastName = nameParts?.slice(1).join(" ") || "";
                } else {
                  firstName = items?.first_name;
                  lastName = items?.last_name;
                }
                return {
                  _id: items?._id,
                  label: firstName + " " + lastName + " - " + items?.email,
                  value: items?.email,
                  position: items?.designation,
                  first_name: firstName,
                  last_name: lastName,
                  isEnabled: true,
                };
              })
          );
        } else {
          console.log("Employee list message", result.message);
          setResendSurveyOpen({ isOpen: false, data: null });
        }
      } catch (error) {
        console.log("Error employee list catch", error.message);
        setResendSurveyOpen({ isOpen: false, data: null });
      }
    }
    employeeData();
  }, []);

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold">
          {t("executives") + " - " + user?.company_name}
        </div>
        <div className="sm:ml-auto flex justify-end items-center space-x-2">
          <div className="">
            <Button
              buttonType={"button"}
              buttonIcon={"fa-solid fa-paper-plane"}
              buttonIconPosition={"left"}
              buttonLabel={t("resend_survey")}
              buttonHasLink={false}
              //buttonLink={"/add-executive"}
              functions={() => {
                if (selectedMember.length > 0) {
                  setResendSurveyOpen({ isOpen: true, data: "all" });
                } else {
                  toastr.warning("Please Select a Executives");
                }
              }}
            />
          </div>
          {role &&
            (role === "customer-admin" ||
              role === "customer-subadmin" ||
              role === "customer-executive") && (
              <div className="">
                <Button
                  buttonType={"button"}
                  buttonIcon={"fa-light fa-plus"}
                  buttonIconPosition={"left"}
                  buttonLabel={t("add_executive")}
                  buttonHasLink={false}
                  //buttonLink={"/add-executive"}
                  functions={() => setEnabledInvitationPopup(true)}
                />
              </div>
            )}
        </div>
      </div>
      {/* <BoardMemeberAlert /> */}
      <div className="relative flex justify-between items-center mb-4">
        &nbsp;
      </div>

      <div className="relative flex gap-3 items-center mb-3 flex-wrap mt-2">
        {executives?.filter((member) => member?.parent_id).length > 0 && (
          <div
            className=""
            data-tooltip-id={`selectAllButton${134}`}
            data-tooltip-place="top"
          >
            <Button
              buttonType={"button"}
              buttonClasses={
                "bg-transparent border border-transparent !text-teal-500 ml-2"
              }
              buttonLabelClasses="text-teal-500"
              buttonIcon={
                areAllSelected
                  ? "fa-solid fa-square-check"
                  : "fa-light fa-square"
              }
              buttonIconPosition={"left"}
              buttonLabel={
                areAllSelected
                  ? "Unselect All Executives For Reset Survey"
                  : "Select All Executives For Reset Survey"
              }
              buttonHasLink={false}
              functions={() => handleSelectAll()}
            />
            <Tooltip
              id={`selectAllButton${134}`}
              className="!text-xs !bg-teal-500 z-50 rounded py-2 px-2 !opacity-100"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">
                      {areAllSelected
                        ? "Unselect All Invited Executives"
                        : "Select All Invited Executives"}
                    </div>
                  </div>
                </div>
              )}
            />
          </div>
        )}
        {/* <div className="relative w-40">
          <Select
            xPlacement={"left"}
            dropdownButtonClass={"!bg-white"}
            dropdownClass={"w-auto"}
            selectedValue={limit}
            dropdownData={[
              { _id: 1000000, label: t("all_items"), value: 1000000 },
              ...[
                { _id: 10, label: "10 " + t("items"), value: 10 },
                { _id: 20, label: "20 " + t("items"), value: 20 },
                { _id: 30, label: "30 " + t("items"), value: 30 },
                { _id: 50, label: "50 " + t("items"), value: 50 },
                { _id: 100, label: "100 " + t("items"), value: 100 },
              ],
            ]}
            getSelectedValue={(e) => {
              setLimit(e.value);
              setSelectedMember([]);
            }}
          />
        </div>
        <div className="relative w-60">
          <Search
            placeholder={t("search")}
            setInput={setKeyword}
            setSelectedMember={setSelectedMember}
          />
        </div> */}
      </div>
      <div className="w-full overflow-auto scroll-smooth scrollbar min-h-[480px] mb-4">
        {totalDataCount > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-2 sm:gap-3">
            {executives.length > 0 &&
              executives.map((item, index) => {
                {/* let namelatter = getInitials(
                  item.first_name + " " + item.last_name
                ); */}
                let totalQuestion = reatingOptions?.length;
                let filterAnswer =
                  item?.executiveAudits?.length > 0 &&
                  item?.executiveAudits.filter(
                    (it) =>
                      it?.answerId !== null || it?.ids?.length > 0 || it?.isNone
                  );
                let totalAnswer = filterAnswer?.length;
                return (
                  <div
                    className="relative w-full bg-white border border-gray-200 rounded-lg shadow overflow-hidden"
                    key={index}
                  >
                    {totalQuestion === totalAnswer ? (
                      <div className="absolute top-0 left-0">
                        <div className="text-white bg-green-500 rounded-br-xl py-2 px-3 !leading-none text-xs font-medium">
                          {t("completed")}
                        </div>
                      </div>
                    ) : (
                      <div className="absolute top-0 left-0">
                        <div className="text-white bg-rose-500 rounded-br-xl py-2 px-3 !leading-none text-xs font-medium">
                          {t("in_completed")}
                        </div>
                      </div>
                    )}
                    <div className="flex justify-end px-2">
                      {/* {item?.email_verified !== 1 && ( */}
                      <CardAction
                        xPlacement={"right"}
                        dropdownData={[
                          // {
                          //   _id: 1,
                          //   label: t("edit"),
                          //   icon: "fa-pen-to-square",
                          //   link: "/executive/edit/" + item?._id,
                          //   type: "link",
                          //   standout: false,
                          //   value: item?._id,
                          //   buttonType: "",
                          //   ordering: 1,
                          // },
                          // {
                          //   _id: 2,
                          //   label: t("start_survey"),
                          //   icon: "fa-clock",
                          //   link: "/",
                          //   type: "button",
                          //   standout: false,
                          //   value: item?._id,
                          //   buttonType: "survey",
                          //   ordering: 1,
                          // },
                          item?.parent_id && item?.email_verified !== 1
                            ? {
                                _id: 4,
                                label: t("resend_invitation"),
                                icon: "fa-envelope",
                                link: "/",
                                type: "button",
                                standout: false,
                                value: item?._id,
                                buttonType: "resend-invitation-executive",
                                ordering: 1,
                              }
                            : "",
                          {
                            _id: 2,
                            label: t("resend_survey"),
                            icon: "fa-solid fa-paper-plane",
                            link: "/",
                            type: "button",
                            standout: false,
                            value: item,
                            buttonType: "resendSurvey",
                            ordering: 2,
                          },
                          // {
                          //   _id: 2,
                          //   label: t("history"),
                          //   icon: "fa-rectangle-history",
                          //   link: "/",
                          //   type: "button",
                          //   standout: false,
                          //   value: item?._id,
                          //   buttonType: "survey-history",
                          //   ordering: 1,
                          // },
                          // {
                          //   _id: 3,
                          //   label: t("details"),
                          //   icon: "fa-eye",
                          //   link: "/executive/details/" + item?._id,
                          //   type: "link",
                          //   standout: false,
                          //   value: item?._id,
                          //   buttonType: "",
                          //   ordering: 2,
                          // },
                          // (!item?.parent_id)?
                          // {
                          //   _id: 4,
                          //   label: t("send_invite"),
                          //   icon: "fa-envelope",
                          //   link: "/",
                          //   type: "button",
                          //   standout: false,
                          //   value: item?._id,
                          //   buttonType: "send-invitation-executive",
                          //   ordering: 3,
                          // }:'',

                          {
                            _id: 6,
                            label: t('delete'),
                            icon: 'fa-trash-can',
                            link: '/',
                            type: 'button',
                            standout: true,
                            value: item?._id,
                            buttonType: 'delete',
                            ordering : 10
                          },
                          item?.email_verified === 1
                            ? {
                                _id: 3,
                                label: t("update_password"),
                                icon: "fa-key",
                                link: "/",
                                type: "button",
                                standout: false,
                                value: item,
                                buttonType: "update-password",
                                isVisabled: 1,
                                ordering: 3,
                              }
                            : "",
                        ]}
                        getActionValue={(obj) => setActionValue(obj)}
                      />
                      {/* )} */}
                      {item?.parent_id && (
                        <div
                          className="flex items-center justify-between py-2"
                          key={index}
                        >
                          <input
                            type="checkbox"
                            id={`${item?._id}`}
                            checked={selectedMember.some(
                              (member) => member?._id === item?._id
                            )}
                            onChange={() => handleSelectedMember(item)}
                            className="border cursor-pointer w-5 h-5 border-slate-400 focus:ring-transparent checked:rounded-full rounded-full checked:text-teal-500   checked:hover:bg-teal-500 checked:bg-teal-500 "
                          />
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col items-center pb-10 space-y-2">
                      <div className="w-16 h-16 overflow-hidden bg-slate-100 rounded-full relative flex items-center justify-center border border-white font-bold">
                        {/* {namelatter} */}
                        <Indentification
                          initial={initialsValue(
                            item?.first_name + " " + item?.last_name
                          )}
                          alt={"shortName"}
                          fill={true}
                          className={""}
                          size={"xl"}
                          initialClass={"!text-xl"}
                        />
                      </div>
                      <div className="text-center">
                        <h5 className="text-base sm:text-base font-bold text-gray-900 capitalize">
                          {item?.first_name + " " + item?.last_name}
                        </h5>
                        <h5 className="text-[12px] font-bold text-slate-500">
                          {item?.email || "N/A"}
                        </h5>
                        {/* <div className="flex justify-center mt-2">
                          {
                            (item?.parent_id)?
                            (item?.email_verified && item?.email_verified === 1)?
                            <div className="text-sm flex items-center space-x-1 text-green-500">
                              <i className="fa-regular fa-fw fa-check-circle"></i>
                              <span className="text-xs font-semibold">{t('invite_accecpted')}</span>
                            </div>:
                            <div className="text-sm flex items-center space-x-1 text-yellow-500">
                              <i className="fa-regular fa-fw fa-clock"></i>
                              <span className="text-xs font-semibold">{t('invited')}</span>
                            </div>:
                            <div className="text-sm flex items-center space-x-1 text-red-500">
                              <i className="fa-regular fa-fw fa-circle-xmark"></i>
                              <span className="text-xs font-semibold">{t('not_invited')}</span>
                            </div>
                          }                          
                        </div> */}
                      </div>
                      <div className="flex justify-center mt-2">
                        {item?.parent_id ? (
                          item?.email_verified && item?.email_verified === 1 ? (
                            <div className="text-sm flex items-center space-x-1 text-green-500">
                              <i className="fa-regular fa-fw fa-check-circle"></i>
                              <span className="text-xs font-semibold">
                                {t("invite_accecpted")}
                              </span>
                            </div>
                          ) : (
                            <div className="text-sm flex items-center space-x-1 text-yellow-500">
                              <i className="fa-regular fa-fw fa-clock"></i>
                              <span className="text-xs font-semibold">
                                {t("invited")}
                              </span>
                            </div>
                          )
                        ) : (
                          <div className="text-sm flex items-center space-x-1 text-red-500">
                            <i className="fa-regular fa-fw fa-circle-xmark"></i>
                            <span className="text-xs font-semibold">
                              {t("not_invited")}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="text-sm flex items-center space-x-1">
                        <div className="text-slate-500">Invitation:</div>
                        <span className="text-xs font-semibold text-slate-800">
                          {item && item?.created_at
                            ? moment(new Date(item?.created_at)).format("ll")
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="relative bg-white shadow rounded">
            <div className="py-8 px-4 w-full">
              {loading ? (
                <div className="p-4 sm:p-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {Array(12)
                      .fill(null)
                      .map((_, index) => (
                        <ProfileCardSkeleton key={index} />
                      ))}
                  </div>
                </div>
              ) : (
                <NoDataFound label={t("no_executive_found")} />
              )}
            </div>
          </div>
        )}
      </div>
      {enabledInviteExecutivePopup && (
        <ManageInviteExecutivePopup
          isOpen={enabledInviteExecutivePopup}
          setIsOpen={(val) => setEnabledInviteExecutivePopup(val)}
          data={inviteInfo}
          getActionValue={(obj) => {
            setActionValue(obj);
            setEnabledInviteExecutivePopup(false);
          }}
        />
      )}
      {enabledSurveyPopup && (
        <SurveyPopup
          isOpen={enabledSurveyPopup}
          setIsOpen={(val) => setEnabledSurveyPopup(val)}
          data={answers}
          surveyFor={"executive"}
          isConfirmation={detailsId ? true : false}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledInvitationPopup && (
        <InvitationPopup
          isOpen={enabledInvitationPopup}
          setIsOpen={(val) => setEnabledInvitationPopup(val)}
          data={answers}
          surveyFor={"executive"}
          isConfirmation={detailsId ? true : false}
          getActionValue={(obj) => {
            setActionValue(obj);            
            setIsUpdate(true);
          }}
          completedUsers={completedUsers}
        />
      )}
      {enabledSurveyHistoryPopup && (
        <SurveyHistoryPopup
          isOpen={enabledSurveyHistoryPopup}
          setIsOpen={(val) => setEnabledSurveyHistoryPopup(val)}
          data={details}
          surveyFor={"executive"}
          isConfirmation={detailsId ? true : false}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {resendSurveyOpen?.isOpen && (
        <ResendSurveyPopup
          isOpen={resendSurveyOpen?.isOpen}
          setIsOpen={setResendSurveyOpen}
          data={resendSurveyOpen?.data}
          executives={executives}
          loadList={loadList}
          setSelectedMember={setSelectedMember}
          selectedMember={selectedMember}
          employees={assignEmployees}
          setEmployees={setAssignEmployees}
        />
      )}
      {enabledPasswordManagePopup && (
        <ManagePasswordPopup
          isOpen={enabledPasswordManagePopup}
          setIsOpen={(val) => setEnabledPasswordManagePopup(val)}
          data={passwordInfo}
          getActionValue={(obj) => {
            setActionValue(obj);
            setEnabledPasswordManagePopup(false);
          }}
        />
      )}
    </>
  );
};

export default Executives;
